import { API_TIMEOUT } from '../timeoutConfig';

export const TOKEN_REFRESH_TIMEOUT_MS = API_TIMEOUT;
export const AUTH_INITIALIZATION_TIMEOUT_MS = API_TIMEOUT;

let terminalChatAuthRecoveryCallback: ((error: unknown) => Promise<boolean>) | null = null;

let isTokenRefreshing = false;
const refreshCallbacks: (() => void)[] = [];

export const waitForTokenRefresh = (): Promise<void> => {
  if (!isTokenRefreshing) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    refreshCallbacks.push(resolve);
    setTimeout(resolve, TOKEN_REFRESH_TIMEOUT_MS);
  });
};

export const setTokenRefreshing = (refreshing: boolean) => {
  isTokenRefreshing = refreshing;

  if (!refreshing) {
    refreshCallbacks.forEach(callback => callback());
    refreshCallbacks.length = 0;
  }
};

export const getIsTokenRefreshing = (): boolean => isTokenRefreshing;

let isAuthInitialized = false;
const authInitCallbacks: (() => void)[] = [];

export const waitForAuthInitialization = (): Promise<void> => {
  if (isAuthInitialized) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    authInitCallbacks.push(resolve);
    setTimeout(resolve, AUTH_INITIALIZATION_TIMEOUT_MS);
  });
};

export const setAuthInitialized = (initialized: boolean) => {
  isAuthInitialized = initialized;

  if (initialized) {
    authInitCallbacks.forEach(callback => callback());
    authInitCallbacks.length = 0;
  }
};

export const getIsAuthInitialized = (): boolean => isAuthInitialized;

export const setTerminalChatAuthRecoveryCallback = (
  callback: ((error: unknown) => Promise<boolean>) | null
) => {
  terminalChatAuthRecoveryCallback = callback;
};

export const recoverTerminalChatAuthFailure = async (error: unknown): Promise<boolean> => {
  if (!terminalChatAuthRecoveryCallback) {
    return false;
  }

  return terminalChatAuthRecoveryCallback(error);
};
